import React from 'react';
import { Route, Switch, Redirect} from 'react-router-dom';
import Main from '../Pages/Main/Main';
// import PageNotFound from '../Pages/PageNotFound';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Login from '../Pages/Login/Login';
import Home from '../Pages/Main/Home';
import About from '../Pages/Main/About';
import Contact from '../Pages/Main/Contact';
import Portfolio from '../Pages/Main/Portfolio';
import PortfolioSingle from '../Pages/Main/PortfolioSingle';
import DashboardPage from '../Pages/Dashboard/Pages/DashboardPage';
import DashboardHome from '../Pages/Dashboard/Pages/Home/DashboardHome';
import DashboardAbout from '../Pages/Dashboard/Pages/About/DashboardAbout';
import DashboardContact from '../Pages/Dashboard/Pages/DashboardContact';
import DashboardPortfolio from '../Pages/Dashboard/Pages/Portfolio/DashboardPortfolio';
import PortfolioEdit from '../Pages/Dashboard/Pages/Portfolio/Sub-Page/PortfolioEdit';
import DashboardSocialMedia from '../Pages/Dashboard/Pages/DashboardSocial';
import PageNotFound from '../Pages/PageNotFound';
import ProtectedRoute from '../Components/Main/protectedroutes';


const Routes = ()=> {
  // const {pathname} = useLocation();
    return(
      <Switch>
        <Route path="/login" component={Login}/>
        {/* <Route exact path="*" component={PageNotFound} /> */}
        
        {/* <Route exact path="/main" component={Main} /> */}
        <Route path='/dashboard/:path?/:path?' exact>
          <Dashboard>
            <Switch>
              <ProtectedRoute exact path="/dashboard" component={DashboardPage} />
              <ProtectedRoute  path="/dashboard/home" component={DashboardHome} />
              <ProtectedRoute  path="/dashboard/about" component={DashboardAbout} />
              <ProtectedRoute  path="/dashboard/contact" component={DashboardContact} />
              <ProtectedRoute  path="/dashboard/portfolio" component={DashboardPortfolio} />
              <ProtectedRoute  path="/dashboard/work/:id" exact component={PortfolioEdit}/>
              <ProtectedRoute  path="/dashboard/social" component={DashboardSocialMedia} />
            </Switch>
          </Dashboard>
        </Route>

        {/* Main page routes */}
        <Route>
          <Main>
            <Switch>
            <Route exact path="/" 
                render={() => {
                  return (
                      <Redirect to="/main"/>
                  )
                }}
              />
              {/* <Route exact path="/" component={Home} /> */}
              <Route  exact path="/main" component={Home} />
              <Route  exact path="/main/about" component={About} />
              <Route  exact path="/main/contact" component={Contact} />
              <Route  exact path="/main/portfolio" component={Portfolio} />
              <Route  exact path="/main/portfolio/:id" component={PortfolioSingle} />
            </Switch>
          </Main>
        </Route>

        
        {/* <Route exact path="*" component={Main} /> */}
      </Switch>
    );
}

export default Routes;
